import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import { supabase } from './supabase';
import Home from './components/Home';
import CreateQuiz from './components/CreateQuiz';
import ParticipateQuiz from './components/ParticipateQuiz';
import Quiz from './components/Quiz';
import History from './components/History';
import logo from './assets/logo.png';
import './App.css';

export const SupabaseContext = React.createContext();

// Custom ProtectedLink component to handle restricted navigation
function ProtectedLink({ to, children, session }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    if (!session && to !== '/') {
      alert('Please log in first.');
      navigate('/'); // Redirect to Home (login page) if not logged in
    } else {
      navigate(to); // Navigate to the intended route if logged in
    }
  };

  return (
    <Link to={to} onClick={handleClick}>
      {children}
    </Link>
  );
}

function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      console.log('Auth state changed:', session ? 'Logged in' : 'Logged out');
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <SupabaseContext.Provider value={{ supabase, session }}>
      <Router>
        <div>
          <header className="app-header">
            <div className="app-logo">
              <img src={logo} alt="Pixel Quiz Logo" />
              <span>PIXEL QUIZ</span>
            </div>
            <nav className="nav-links">
              <ProtectedLink to="/" session={session}>Home</ProtectedLink>
              <ProtectedLink to="/create" session={session}>Create Quiz</ProtectedLink>
              <ProtectedLink to="/participate" session={session}>Participate</ProtectedLink>
              <ProtectedLink to="/history" session={session}>History</ProtectedLink>
            </nav>
          </header>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/create" element={<CreateQuiz />} />
            <Route path="/participate" element={<ParticipateQuiz />} />
            <Route path="/quiz/:code" element={<Quiz />} />
            <Route path="/history" element={<History />} />
          </Routes>
        </div>
      </Router>
    </SupabaseContext.Provider>
  );
}

export default App;